module.exports = __webpack_public_path__ + "static/avatar-923e65a1d6b32c7b95cf0c9165bb8ec6.jpg";